import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Tab,
  Tabs,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import UserAuditLogTable from "../../features/manageUsers/userAuditLogTable";
import VerificationModal from "../../Modals/verificationModal";
import {
  useLazyGetUserByIdQuery,
  useLazyGetProductByUserIdQuery,
} from "../../service/users";
import Loader from "../../constants/Loader";
import { showError } from "../../constants/toasts";
import { USER } from "../../types/User";
import { PRODUCT_STATUS } from "../../constants/enums";
import moment from "moment";
import { useLazyGetUserFollowersQuery } from "../../service/followers";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageUserDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [userData, setUserData] = useState<USER | null>(null);
  interface Product {
    _id: string;
    name: string;
    image: string;
    title: string;
    category: string;
    date: string;
    status: string;
  }

  const [userProducts, setUserProducts] = useState<any[] | null>(null);
  const [userFollowers, setUserFollowers] = useState<any[] | null>(null);

  const [getUserById, { isLoading: isLoadingUser, error: userError }] =
    useLazyGetUserByIdQuery();
  const [getProductById] = useLazyGetProductByUserIdQuery();
  const [getUserFollowers] = useLazyGetUserFollowersQuery();

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const fetchUserDetails = async () => {
    if (!id) return;
    try {
      const response = await getUserById({ id }).unwrap();
      if (response.code === 200) {
        setUserData(response?.data || null);
      } else {
        showError("Failed to fetch user details");
        setUserData(null);
      }
    } catch (error: any) {
      console.error("Error fetching user details:", error);
      setUserData(null);
      showError(error?.data?.message || "Failed to fetch user details");
    }
  };

  const fetchUserProducts = async () => {
    if (!id) return;
    try {
      const response = await getProductById(id).unwrap();
      if (response.code === 200) {
        console.log(response?.data?.list, "response");
        setUserProducts(response?.data?.list || null);
      }
    } catch (error: any) {
      console.error("Error fetching products details:", error);
      setUserProducts(null);
      showError(error?.data?.message || "Failed to fetch products details");
    }
  };

  const fetchUserFollowers = async () => {
    if (!id) return;
    try {
      const response = await getUserFollowers({ id }).unwrap();
      if (response.code === 200) {
        console.log(response?.data?.list, "response");
        setUserFollowers(response?.data?.list || null);
      }
    } catch (error: any) {
      console.error("Error fetching products details:", error);
      setUserFollowers(null);
      showError(error?.data?.message || "Failed to fetch products details");
    }
  };

  const followers = [
    {
      id: 101,
      name: "John Doe",
      email: "john@example.com",
      since: "10-Aug-2025",
    },
    {
      id: 102,
      name: "Jane Smith",
      email: "jane@example.com",
      since: "22-Aug-2025",
    },
  ];

  const userActivityLogs = [
    {
      id: 1,
      activity: "Viewed Product",
      itemType: "Product",
      itemTitle: "Vintage Camera",
      itemCode: "PROD001",
      productId: 1,
      dateTime: "03-Sep-2025 10:30 AM",
    },
    {
      id: 2,
      activity: "Viewed Product",
      itemType: "Product",
      itemTitle: "Programming Books Bundle",
      itemCode: "PROD003",
      productId: 2,
      dateTime: "02-Sep-2025 05:15 PM",
    },
    {
      id: 3,
      activity: "Login",
      itemType: "Account",
      itemTitle: "Successful Login",
      itemCode: "-",
      productId: null,
      dateTime: "02-Sep-2025 09:02 AM",
    },
  ];

  useEffect(() => {
    if (valueTabs === 0) {
      fetchUserDetails();
    }
    if (valueTabs === 1) {
      fetchUserProducts();
    }
    if (valueTabs === 2) {
      fetchUserFollowers();
    }
  }, [valueTabs]);

  return (
    <>
      <div className="main_title">
        <h1>User Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-users")}>
            Manage Users
          </button>{" "}
          - User Detail
        </p>
      </div>
      <Loader isLoad={isLoadingUser} />
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              className="custom_tabs_links"
            >
              <Tab label="Personal Info" {...a11yProps(0)} />
              <Tab label="Product Listing" {...a11yProps(1)} />
              <Tab label="Followers" {...a11yProps(2)} />
              <Tab label="Logs" {...a11yProps(3)} />
            </Tabs>
          </Box>
        </div>
      </div>

      {/* Personal Info */}
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="cards view_page">
          <div className="table_header">
            <h2>Personal Info</h2>
            {/* <div className="right_s">
              <Button
                className="btn btn_primary sm"
                onClick={() => setOpenModal(true)}
              >
                Resend Verification
              </Button>
            </div> */}
          </div>
          <div className="gap_p">
            <div className="vew_img w_100">
              <h6>Image</h6>
              <figure>
                <img
                  alt="user"
                  src={userData?.image || "/static/images/user_placeholder.png"}
                />
              </figure>
            </div>
            <div className="w_33">
              <h6>First Name</h6>
              <p>{userData?.firstName || "-"}</p>
            </div>
            <div className="w_33">
              <h6>Last Name</h6>
              <p>{userData?.lastName || "-"}</p>
            </div>
            <div className="w_33">
              <h6>Email Address</h6>
              <p>{userData?.email || "-"}</p>
            </div>
            <div className="w_33">
              <h6>Phone</h6>
              <p>
                {userData?.countryCode || ""}
                {userData?.phone || ""}
                {/* <img src="/static/images/tick_icon.svg" alt="verified" />{" "} */}
              </p>
            </div>
            <div className="w_33">
              <h6>Date Registered</h6>
              <p>
                {userData?.createdAt
                  ? moment(userData?.createdAt).format("lll")
                  : "-"}
              </p>
            </div>
            <div className="w_33">
              <h6>Address</h6>
              <p>{userData?.address?.addressLine1 || "-"}</p>
            </div>
            <div className="w_33">
              <h6>City</h6>
              <p>{userData?.address?.city || "-"}</p>
            </div>
            <div className="w_33">
              <h6>Country</h6>
              <p>{userData?.address?.country || "-"}</p>
            </div>
            <div className="w_33">
              <h6>Account Status</h6>
              <p>{!userData?.isBlocked ? "Active" : "In-Active"}</p>
            </div>
          </div>
        </div>
      </CustomTabPanel>

      {/* Product Listing */}
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>Product Listing</h2>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  {/* <TableCell>Product ID</TableCell> */}
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userProducts?.map((p: any) => (
                  <TableRow hover key={p._id}>
                    {/* <TableCell>{p.referenceId}</TableCell> */}
                    <TableCell>
                      <Box>
                        {p?.images.length > 0 && (
                          <img
                            style={{
                              height: 40,
                              width: 80,
                              objectFit: "cover",
                            }}
                            src={p.images[0]}
                            alt={p.name}
                          />
                        )}
                      </Box>
                    </TableCell>
                    <TableCell>{p?.name}</TableCell>
                    <TableCell>
                      {p?.category?.name}
                      <br />
                      <small>{p?.subcategory?.name}</small>
                    </TableCell>
                    <TableCell>{p?.createdAt}</TableCell>
                    <TableCell>
                      {p?.status === PRODUCT_STATUS.PENDING && "Pending"}
                      {p?.status === PRODUCT_STATUS.APPROVED && "Approved"}
                      {p?.status === PRODUCT_STATUS.REJECTED && "Rejected"}
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-products/detail/${p._id}`)
                          }
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                        <IconButton
                          onClick={() =>
                            navigate(`/manage-products/edit/${p._id}`)
                          }
                        >
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomTabPanel>

      {/* Followers */}
      <CustomTabPanel value={valueTabs} index={2}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>Followers</h2>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Since</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userFollowers?.map((f) => (
                  <TableRow hover key={f._id}>
                    <TableCell>{f?.user?.fullName}</TableCell>
                    <TableCell>{f?.user?.email || "-"}</TableCell>
                    <TableCell>
                      {f?.createdAt
                        ? moment(f.createdAt).format("DD/MM/YYYY")
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() => navigate(`/manage-users/detail`)}
                        >
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomTabPanel>

      {/* Logs */}
      <CustomTabPanel value={valueTabs} index={3}>
        <div className="cards">
          <div className="table_header">
            <div className="left_s">
              <div className="section_title">
                <h2>User Activity Logs</h2>
              </div>
            </div>
          </div>
          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Activity</TableCell>
                  <TableCell>Item</TableCell>
                  <TableCell>Date & Time</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {userActivityLogs.map((log) => (
                  <TableRow hover key={log.id}>
                    <TableCell>{log.activity}</TableCell>
                    <TableCell>
                      <div>
                        <strong>{log.itemTitle}</strong>
                        <br />
                        <small>
                          {log.itemType}
                          {log.itemCode && ` • ${log.itemCode}`}
                        </small>
                      </div>
                    </TableCell>
                    <TableCell>{log.dateTime}</TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        {log.itemType === "Product" && log.productId && (
                          <IconButton
                            onClick={() => navigate(`/manage-products/detail`)}
                          >
                            <img src="/static/images/eye_icon.svg" alt="View" />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </CustomTabPanel>

      <VerificationModal
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageUserDetail;
